<template>
    <div class="pagination-item" :class="classes" v-text="number + '/' + $parent.numberOfPage" @click="actionClick"></div>
</template>

<script>
    export default {
        name: "PaginationItem",
        props: {
            number: {
                type: Number,
                required: true,
            }
        },
        computed: {
            classes() {
                return {
                    'active': this.active,
                }
            },
            active() {
                return this.$parent.numberActivePage === this.number;
            }
        },
        methods: {
            actionClick() {
                this.$parent.numberActivePage = this.number;
            }
        }
    }
</script>